import * as React from "react";
import { SVGProps } from "react";
export function SchoolInstitutionIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 20.071 19.871"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.75 11.766H1.963c-.67 0-1.213.543-1.213 1.213v4.929c0 .67.543 1.213 1.213 1.213H5.75M14.321 11.766h3.785c.671 0 1.215.543 1.215 1.213v4.929c0 .67-.544 1.213-1.215 1.213h-3.785M5.75 10.492a4.286 4.286 0 0 1 8.571 0v8.629H5.75v-8.629ZM10.036 6.207V.75M10.036.75h4.285v2.757h-4.285V.75Z"
        stroke="#000"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.037 12.666a1.751 1.751 0 1 0 0-3.502 1.751 1.751 0 0 0 0 3.502ZM10.036 16.658l.01 2.463"
        stroke="#000"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
